import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-bank-card-line',
      title: 'Wholesale Trade Lines',
      description: 'Access high quality business trade lines at broker pricing. Get the best rates in the industry with fast approval and processing.',
    },
    {
      icon: 'ri-building-line',
      title: 'Done For You Business Credit Building',
      description: 'We handle the full process including vendor accounts, reporting accounts, and profile building. Complete white label service.',
    },
    {
      icon: 'ri-service-line',
      title: 'Broker Fulfillment Services',
      description: 'White label fulfillment so you can focus on closing clients. Our team manages everything from start to finish.',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Client Processing',
      description: 'Our team manages onboarding and fulfillment for your clients. Professional support every step of the way.',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#2F6FE4] mb-4">Our Services</h2>
          <p className="text-xl text-[#555555] max-w-2xl mx-auto">Everything you need to scale your broker business</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-3xl p-12 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 border-t-4 border-[#3D8BFF]">
              <div className="w-24 h-24 flex items-center justify-center bg-[#A9C9FF] rounded-2xl mb-6">
                <i className={`${service.icon} text-5xl text-[#2F6FE4]`}></i>
              </div>
              <h3 className="text-[#2F6FE4] text-2xl font-bold mb-4">{service.title}</h3>
              <div className="w-16 h-0.5 bg-[#3D8BFF] mb-6"></div>
              <p className="text-[#555555] leading-relaxed mb-6">{service.description}</p>
              <Link to="/services" className="inline-flex items-center space-x-2 text-[#2F6FE4] hover:text-[#3D8BFF] transition-colors font-semibold cursor-pointer">
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/services" className="bg-[#2F6FE4] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#3D8BFF] transition-all inline-block whitespace-nowrap cursor-pointer">
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;